import { render } from "./SocialsPage.vue?vue&type=template&id=3a63e28d&scoped=true"
const script = {}

import "./SocialsPage.vue?vue&type=style&index=0&id=3a63e28d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a63e28d"]])

export default __exports__